import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propStr, } from '../../../../../helpers/custom-prop-types';
import SplitText from '../../../../Ui/Common/SplitText';
import AboutAccordion from '../AboutAccordion';
import Description from '../Description';
import ResearchList from '../ResearchList';
import SkillList from '../SkillList';
import AboutContentsCareers from './AboutContentsCareers';
import AboutContentsPortfolios from './AboutContentsPortfolios';
import AboutContentsTheme from './AboutContentsTheme';
const AboutContents = (props) => {
    const { baseSkills, careers, description, middleTasks, overview, portfolios, projectCareers, } = props;
    return (_jsxs("div", Object.assign({ className: 'l-about-right' }, { children: [overview && (_jsx("section", { children: _jsxs("div", Object.assign({ className: 'about-box is-free' }, { children: [_jsx("h2", Object.assign({ className: 'about-title' }, { children: "ABOUT ME" })), _jsx(SplitText, { className: 'about-text', text: overview, wrap: 'p' })] })) })), _jsx("section", { children: _jsxs("div", Object.assign({ className: 'about-box is-free' }, { children: [_jsx("h2", Object.assign({ className: 'about-title accordion-research-title' }, { children: "SKILLS" })), _jsx(SkillList, { baseSkills: baseSkills }), _jsx(AboutAccordion, Object.assign({ keyId: 'accordion-research', openText: 'details' }, { children: _jsx(ResearchList, { baseSkills: baseSkills }) }))] })) }), middleTasks.length > 0 && (_jsx(AboutContentsTheme, { middleTasks: middleTasks })), portfolios.length > 0 && (_jsx(AboutContentsPortfolios, { portfolios: portfolios })), description && _jsx(Description, { description: description }), (careers.length > 0 || projectCareers.length > 0) && (_jsx(AboutContentsCareers, { careers: careers, projectCareers: projectCareers }))] })));
};
AboutContents.propTypes = {
    baseSkills: propArrayShape().isRequired,
    careers: propArrayShape().isRequired,
    description: propStr(),
    middleTasks: propArrayShape().isRequired,
    overview: propStr(),
    portfolios: propArrayShape().isRequired,
    projectCareers: propArrayShape().isRequired,
};
AboutContents.defaultProps = {
    description: '',
    overview: '',
};
export default AboutContents;
